<template>
    <div>
        <CuentaAtras @tiempoTerminado="volver"/>
        <PageTitle 
            :title="teatro.hash === 'UHmERrsRV19JCGQMg7Is' ? $t('nuevo_abono.titulo_copa', { titulo:  lista_abonados.nombre }) : $t('nuevo_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" 
            class="strech"
        />

        <template v-if="teatro.hash === 'hvLux5tvnE5HMsDiXOt2' && url.includes('n_abonado_antiguo')">
            <SeleccionarAsientosConRegiones 
                v-if="recinto && recinto.tipo_proceso_online == 1 && abonado && !plazas_parking"
                :disabled="paso3" 
                :changeSeat="changeSeat" 
                :abonado="abonado" 
                :key="reloadComponent"
                @butacasBloqueadas="butacasBloqueadas"
            />
        </template>
        <template v-else>
            <SeleccionarAsientosConRegiones
                v-if="!buscando_abonado"
                v-show="recinto && recinto.tipo_proceso_online == 1 && !plazas_parking" 
                :disabled="paso3"
                :changeSeat="changeSeat" 
                :abonado="abonado" 
                :key="reloadComponent"
                @butacasBloqueadas="butacasBloqueadas"
                @sessionButacaData="sessionButacaDataPadre"
            />
        </template>

        <SeleccionarAsientosMapaGeneral 
            v-if="recinto && recinto.tipo_proceso_online == 3" 
        />

        <SeleccionarAsientoConSecciones 
            v-if="recinto && recinto.tipo_proceso_online == 2" 
            :disabled="paso3"
            :changeSeat="changeSeat" 
            @butacasBloqueadas="butacasBloqueadas" 
        />

        <div id="plazas_parking" v-if="zonas_anexas_disponibles && plazas_parking && recinto && recinto.tipo_proceso_online == 1">
            <PasoExtraPlazasParking
                ref="pasoExtraPlazasParking"
                :disabled="paso3"
                :abonado="abonado"
                :changeSeat="changeSeat"
                @avanzarPaso="avanzarPaso"
                @butacasBloqueadas="butacasBloqueadas"
                @sessionButacaData="sessionButacaDataPadre"
                @continuarSinPlazaParking="continuarSinPlazaParking"
            />
        </div>

        <transition name="fade" mode="out-in">
            <section 
                class="padding-vertical-content lightgray-content mb-3 mb-lg-4" 
                v-if="paso3" 
                key="paso3"
                id="paso3"
            >
                <div class="container">
                    <div class="row">
                        <b-col cols="12">
                            <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.completa_datos') }}</h2>
                            <div class="subtitle h3 light mb-3">{{ $t('nuevo_abono.completa_info', {abono: teatro.texto_abono}) }}</div>
                        </b-col>
                        <div class="col-12">
                            <ValidationObserver tag="form" ref="observer" @submit.prevent="finalizarPasoTres()">
                                <div v-for="(abono, index) in datos_compradores" :key="index">
                                    <DatosAbonoComponent 
                                        :abono="abono" 
                                        :generos="generos" 
                                        :index="++index"
                                        :descuentos="zona.precios"
                                        :tipos_abonos="abono.tipos_abonos ?? zona.tipos_abonos"
                                        :desactivar="paso4 || resumen || voucher ? true : false"
                                        :validator="$refs.observer"
                                        :error_telefono="error_telefono" @imagenSubida="documentacion_error = false"
                                        @errorDatos="datos_abono_error = $event"
                                        @updateAbono="actualizarDatosAbonado($event)"
                                        @precioDisponible="precio_disponible = $event"
                                    />
                                </div>
                                <div class="mt-4" v-if="datos_abono_error">
                                    <b-alert show variant="danger">
                                        <h3>
                                            {{ $t('renovar_abono.no_precios') }}
                                        </h3>                                        
                                    </b-alert>
                                </div>
                                <div class="mt-4" v-if="documentacion_error">
                                    <h4 class="text-danger">
                                        {{ $t('nuevo_abono.error_documentacion') }}
                                    </h4>
                                </div>
                                <div class="mt-4" v-if="dni_error">
                                    <h4 class="text-danger">
                                        {{$t('nuevo_abono.existe_dni', {abono: teatro.texto_abono})}}
                                    </h4>
                                </div>
                                <div class="mt-4" v-if="!precio_disponible">
                                    <h4 class="text-danger">
                                        {{ $t('nuevo_abono.error_precio') }}
                                    </h4>
                                </div>
                                <div class="mt-4 form-button-responsive">
                                    <button 
                                        v-if="!datos_abono_error" 
                                        id="compra-responsive" 
                                        type="submit"
                                        :class="'button effect-button' + (!esMovil ? ' large-button pb-3' : ' pt-2') "
                                        :disabled="paso4 || resumen ? true : false"
                                    >
                                        <span :style="{ fontSize: esMovil ? '12px' : '16px' }">   
                                            {{$t('nuevo_abono.continuar_compra') }}
                                        </span>
                                    </button>
                                    <button 
                                        id="atras-responsive" 
                                        @click.prevent="cambiarAsiento"
                                        :class="'button effect-button ml-2' + (!esMovil ? ' large-button pb-3' : '')"
                                        :disabled="paso4 || resumen || voucher ? true : false"
                                    >
                                        <span :style="{ fontSize: esMovil ? '12px' : '16px' }">
                                            {{$t('nuevo_abono.volver_compra') }}
                                        </span>
                                    </button>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <div v-if="lista_abonados.permitir_envio_a_domicilio">
            <transition name="fade" mode="out-in">
                <section class="padding-vertical-content" v-if="paso4" key="paso4" id="paso4">
                    <div class="container">
                        <div class="row">
                            <EnviosComponent 
                                :datos_compradores="datos_compradores"
                                :desactivar="voucher || resumen ? true : false" 
                                @envioSolicitado="envioSolicitado"
                                @continuarSinEnvio="showVoucher"
                                @atras="volverDesdePreguntaEnvio"
                            />
                        </div>
                    </div>
                </section>
            </transition>
        </div>

        <transition name="fade" mode="out-in">
            <section
                :class="'padding-vertical-content ' + (lista_abonados.permitir_envio_a_domicilio ? 'lightgray-content' : '')"
                v-if="voucher" 
                key="voucher" 
                id="voucher"
            >
                <div class="container">
                    <div class="row">
                        <b-col cols="12" class="mt-3 mb-3">
                            <CheckVoucherComponent 
                                :sesion_id="session_id" 
                                :datos="datos_compradores"
                                :desactivar="resumen || procesar_pago || preguntaParcelas ? true : false" 
                                :loading="resumen_loading"
                                :esMovil="esMovil" 
                                @volver="voucher = false" 
                                @continuar="cuponAplicado()" 
                            />
                        </b-col>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <PreguntaPrevioPasoParcelas 
                :mostrar="preguntaParcelas"
                :esMovil="esMovil"
                :loading="loading"
                :botonesDeshabilitados="botonesParcelasDeshabilitados"
                @quiereParcelas="respuestaParcelas"
                @volver="volverDesdePreguntaParcelas"
            />
        </transition>

        <transition name="fade" mode="out-in">
            <PasoCompraParcelasOnline 
                ref="pasoParcelasRef"
                :mostrar="pasoSeleccionParcelas"
                :datosCompradores="datos_compradores"
                :esMovil="esMovil"
                :loading="loading"
                :sesiones="sessiones"
                @continuar="continuarDespuesdeAsignaciones"
                @volver="volverDesdeSeleccionParcelas"
            />
        </transition>

        <transition name="fade" mode="out-in">
            <section
                :class="'padding-vertical-content mb-3 mb-lg-4 ' + (!lista_abonados.permitir_envio_a_domicilio || quiereParcelasCambiarColor  ? 'lightgray-content' : 'bg-white')"
                v-if="resumen" 
                key="resumen" 
                id="resumen"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <template v-if="!resumen_error">
                                <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.resumen_compra') }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('nuevo_abono.revisa_datos') }}</div>
                                <ResumenCompraComponent 
                                    :entradas="asientos" 
                                    :formulario="formulario"
                                    :datos_guardados="datos_guardados" 
                                    :envio_domicilio="envio_domicilio"
                                    :datos_parcelas_compra="datos_parcelas_compradas"
                                    @solicitarPlazos="aplicarPlazos" 
                                    @compraConfirmada="compraConfirmada"
                                    :iva="footer.iva_abono"
                                    :activar_referidos="teatro.activar_referidos && ! renovacion"
                                    :session_id="session_id"
                                    :activar_saldo_monedero="teatro.activar_referidos && renovacion"
                                    @aplicarDescuento="aplicarDescuento" 
                                    @cancelarDescuento="cancelarDescuento"
                                    @resetPlazos="resetPlazos" 
                                    :loading="resumen_loading"
                                    :desactivar="procesar_pago ? true : false" 
                                    @volver="volverDesdeResumenCompra"
                                    :esMovil="esMovil"
                                />
                            </template>
                            <template v-else>
                                <h2 class="m-0 h1 text-uppercase">{{ resumen_error }}</h2>
                            </template>
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section 
                v-if="procesar_pago"
                :class="'padding-vertical-content mb-3 mb-lg-4 ' + (lista_abonados.permitir_envio_a_domicilio ? 'lightgray-content' : '')"
                key="pago" 
                id="pago"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent 
                                ref="pago" 
                                :tipo_venta="tipo_venta" 
                                :jet_id="jet_id"
                                :session_id="session_id" 
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
    import DatosAbonoComponent from '@/components/frontend/abonos/nuevo/DatosAbonoComponent';
    import ResumenCompraComponent from '@/components/frontend/abonos/nuevo/ResumenCompraComponent';
    import Generos from "@/mixins/Generos";
    import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent"
    import EnviosComponent from '@/components/frontend/abonos/nuevo/EnviosComponent.vue';
    import CheckVoucherComponent from '@/components/frontend/abonos/nuevo/CheckVoucherComponent.vue';
    import SeleccionarAsientosConRegiones from '@/components/frontend/abonos/nuevo/SeleccionarAsientosConRegiones.vue';
    import SeleccionarAsientosMapaGeneral from '@/components/frontend/abonos/nuevo/SeleccionarAsientosMapaGeneral.vue';
    import SeleccionarAsientoConSecciones from './SeleccionarAsientoConSecciones.vue';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import PasoCompraParcelasOnline from '@/components/frontend/abonos/parcelas/PasoCompraParcelasOnline.vue';
    import PreguntaPrevioPasoParcelas from '@/components/frontend/abonos/parcelas/PreguntaPrevioPasoParcelas.vue';
    import PasoExtraPlazasParking from './PasoExtraPlazasParking.vue';

    export default {
        mixins: [Generos],
        head: {
            title: function() {
                return {
                    inner: 'Venta de abonos',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }                   
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        data() {
            return {
                paso3: false,
                paso4: false,
                pasoSeleccionParcelas: false,
                resumen: false,
                zona: null,
                asientos: [],
                datos_compradores: [],
                session_id: null,
                formulario: null,
                datos_guardados: null,
                loading: false,
                resumen_loading: false,
                resumen_error: null,
                documentacion_error: false,
                direccion_envio_abono: '',
                time_left: null,
                compra_loading: null,
                procesar_pago: false,
                envio_domicilio: false,
                jet_id: null,
                dni_error: false,
                datos_abono_error: null,
                voucher: false,
                reloadComponent: 1,
                changeSeat: 1,
                abonado: null,
                error_telefono: 0,
                tipo_venta: 'abono',
                esMovil: false,
                preguntaParcelas: false,
                botonesParcelasDeshabilitados: false,
                cart_ids_parcelas: [],
                quiereParcelasCambiarColor: false,
                datos_parcelas_compradas: [],
                sessiones: [],
                plazas_parking: false,
                buscando_abonado: true,
                zonas_anexas: [],
                precio_disponible: true
            }
        },
        created() {
            if (this.manager.lfp) {
                this.tipo_venta = 'abono-alta-lfp';
            }

            this.getGeneros();
            if (this.abono_envio) {
                this.abono_envio.gastos_envio = this.lista_abonados.precio_envio_a_domicilio;
            }

            if(this.$route.query.n_abonado_antiguo || this.$route.query.dni) {
                this.buscarAbonado(this.$route.query.n_abonado_antiguo, this.$route.query.dni)
            } else {
                this.buscando_abonado = false;
            }
            
            this.verificarDisponibilidadZonasYVentaActivada();
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }

            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            renovacion() {
                return this.$route.query.dni && this.$route.query.n_abonado_antiguo ? 1 : 0;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            url() {
                return window.location.href;
            },
            zonas_anexas_disponibles() {
                return this.zonas_anexas && this.zonas_anexas.length > 0 && this.zonas_anexas.some(zona => zona.esta_disponible);
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        methods: {
            actualizarDatosAbonado(event) {
                this.$set(this.datos_compradores, event.index, event.data);
            },
            volverDesdePreguntaEnvio() {
                this.paso4 = false;
                this.$nextTick(function() {
                    this.scrollTo('#paso3');
                });
            },
            volver() {

                if(this.pasoSeleccionParcelas && this.$refs.pasoParcelasRef)
                {
                    this.$refs.pasoParcelasRef.limpiarTodo();
                }

                if(this.$route.query.n_abonado_antiguo && this.$route.query.dni) {
                    this.$router.push({ name: 'front.abonos.renovar.index', query: { n_abonado_antiguo: this.$route.query.n_abonado_antiguo, dni: this.$route.query.dni } });
                } else {
                    this.reloadComponent += 1;
                    this.paso3 = false;
                    this.paso4 = false;
                    this.pasoSeleccionParcelas = false;
                    this.zonaParcelasSeleccionada = null; 
                    this.parcelasSleccionadas = [];
                    this.preguntaParcelas = false;
                    this.resumen = false;
                    this.voucher = false;
                    this.$nextTick(function() {
                        this.scrollTo('#paso1');
                    });
                }
            },
            cambiarAsiento() {
                if(this.$route.query.n_abonado_antiguo && this.$route.query.dni) {
                    this.$router.push({ name: 'front.abonos.renovar.index', query: { n_abonado_antiguo: this.$route.query.n_abonado_antiguo, dni: this.$route.query.dni } });
                } else {
                    this.changeSeat += 1;
                    this.paso3 = false;
                    this.paso4 = false;
                    this.resumen = false;
                    this.$nextTick(function() {
                        this.scrollTo('#paso2');
                    });
                }
                this.datos_compradores = [];
                this.asientos = [];
                this.sessiones = [];
                this.borrarSesion();
            },
            borrarSesion(){
                if (sessionStorage.getItem('session_id')) {
                    const params = {
                        session_id: sessionStorage.getItem('session_id'),
                        filters: {
                            session_id: sessionStorage.getItem('session_id'),
                            tid: this.configuracion.hash_teatro
                        },
                        tid: this.configuracion.hash_teatro,
                    };

                    this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                        this.plazas_parking = false;
                        this.reloadComponent++;
                    });

                    sessionStorage.removeItem('session_id');
                }
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            buscarAbonado(n_abonado_antiguo, dni) {
                this.buscando_abonado = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: dni,
                        n_abonado_antiguo: n_abonado_antiguo
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    this.abonado = res.data.abonado;
                    this.abonado.asiento = res.data.asiento;
                    this.abonado.plaza = res.data.plaza;
                    this.abonado.tipos_abonos = res.data.tipos_abonos;
                }).finally(() => this.buscando_abonado = false);
            },
            async finalizarPasoTres() {
                const errors = Object.keys(this.$refs.observer.errors).some(
                    field => this.$refs.observer.errors[field].length > 0
                );

                if(errors) {
                    return;
                }

                const isValid = await this.$refs.observer.validate()
                
                const tienen_telefono = this.datos_compradores.filter(datos_comprador => {
                    return !isNaN(datos_comprador.telefono) && datos_comprador.telefono != null && datos_comprador.telefono_valido;
                }).length === this.datos_compradores.length;
                
                if (isValid && tienen_telefono) {
                    this.error_telefono = 0;
                    this.dni_error = false;

                    var DNI = [];

                    for (var i = 0; i < this.datos_compradores.length; i++) {
                        if(this.datos_compradores[i].precio) {
                            
                            if(!this.datos_compradores[i].precio.solicitar_documentacion) {
                                this.documentacion_error = false;
                            } else if(this.datos_compradores[i].documentaciones && this.datos_compradores[i].documentaciones.length > 0) {
                                this.documentacion_error = false;
                            } else {
                                this.documentacion_error = true;
                                break;
                            }

                        } else {
                            this.documentacion_error = false;
                        }

                        DNI.push(this.datos_compradores[i].dni);
                    }

                    if(DNI.length > 0 && this.manager.comprobar_dni && ! this.renovacion){
                        const params = {
                            filters: {
                                tid: this.configuracion.hash_teatro
                            },
                            dni: DNI
                        }

                        this.$store.dispatch(this.config.getVuexAlias('front.comprobar.datos.comprador.dni'), params).catch(() => {
                            this.dni_error = true;
                        }).finally(()=> {
                            this.finalizarPasoTresComprobados();
                        });

                    }else {
                        this.finalizarPasoTresComprobados();
                    }
                } else {
                    this.error_telefono += 1;
                }
            },
            async finalizarPasoTresComprobados(){
                if(!this.documentacion_error && !this.dni_error) {
                    if (this.lista_abonados.permitir_envio_a_domicilio) {
                        this.paso4 = true;
                        this.$nextTick(function() {
                            this.scrollTo('#paso4');
                        });
                    } 
                    else {
                        this.showVoucher();
                    }
                }
            },
            async envioSolicitado(datos_envio) {
                this.datos_compradores.forEach(datos_comprador => {
                    datos_comprador.datos_envio = [];
                })

                this.datos_compradores[0].datos_envio = {
                    nombre: datos_envio.nombre != "" ? datos_envio.nombre : this.datos_compradores[0].nombre,
                    apellidos: datos_envio.apellidos != "" ? datos_envio.apellidos : this.datos_compradores[0].apellidos,
                    domicilio: datos_envio.domicilio != "" ? datos_envio.domicilio : this.datos_compradores[0].domicilio,
                    cp: datos_envio.cp != "" ? datos_envio.cp : this.datos_compradores[0].cp,
                    telefono: datos_envio.telefono != "" ? datos_envio.telefono : this.datos_compradores[0].telefono,
                    observaciones: datos_envio.observaciones,
                    gastos_envio: datos_envio.gastos_envio,
                    provincia : datos_envio.provincia != "" ? datos_envio.provincia : this.datos_compradores[0].provincia,
                    localidad: datos_envio.localidad != "" ? datos_envio.localidad : this.datos_compradores[0].localidad,
                    importe_total: this.datos_compradores.reduce((acumulador, abono) => {
                        return acumulador + abono.precio ? abono.precio.precio : abono.tipo_abono.precio;
                    }, 0)
                }

                this.envio_domicilio = true;

                this.showVoucher();
                
            },
            aplicarDescuento(descuento) {
                this.datos_compradores[0]['descuento_monedero'] = descuento;
                this.guardarDatos();
            },
            cancelarDescuento() {
                this.datos_compradores[0]['descuento_monedero'] = 0;
                this.guardarDatos();
            },
            guardarDatos() {
                this.resumen_loading = true;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    datos_compradores: this.datos_compradores,
                    session_id: this.session_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    this.datos_guardados = res.data.datos_compradores;
                    this.resumen_loading = false;
                    this.resumen_error = false;
                }).catch(error => {
                    this.resumen_error = error.response.data.message;
                    this.resumen_loading = false;
                });
            },
            aplicarPlazos(datos) {
                this.resumen_loading = true;
                this.datos_guardados = null;
                this.datos_compradores = datos;
                this.resumen = true;
                this.guardarDatos();
            },
            resetPlazos() {
                this.resumen_loading = true;
                this.datos_guardados = null;
                this.datos_compradores.forEach(dato => {
                    dato.plazos = false,
                    dato.plazos_pendientes = null;
                });
                this.resumen = true;
                this.guardarDatos();
            },
            compraConfirmada() {
                this.procesar_pago = true;
                this.$nextTick(function() {
                    this.scrollTo('#pago');
                });
            },
            showModal(modal)  {
                this.$modal.show(modal)
            },
            showVoucher() {
                this.voucher = true;
                this.$nextTick(function() {
                    this.scrollTo('#voucher');
                });
            },
            async cuponAplicado() {
                const parcelasDisponibles = await this.verificarDisponibilidadZonasYVentaActivada();
                if (parcelasDisponibles) {
                    this.preguntaParcelas = true;
                    this.$nextTick(() => {
                        this.scrollTo('#preguntaParcelas');
                    });
                } else {
                    this.$nextTick(() => {
                        this.resumen = true;
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.scrollTo('#resumen');
                            }, 300);
                        });
                    });
                }
                this.guardarDatos();
            },
            butacasBloqueadas(datos_compradores, asientos, zona, session_id, zonas_anexas) {
                this.zonas_anexas = zonas_anexas;
                datos_compradores.forEach(datos_comprador => {
                    if(zona.tipo_svg == 1) {
                        datos_comprador.tipos_abonos = zona.tipos_abonos;
                    }
                    this.datos_compradores.push(datos_comprador);
                });
                asientos.forEach(asiento => {
                    this.asientos.push(asiento);
                });
                this.zona = zona;
                this.session_id = session_id;

                if (!zona.tiene_plazas && this.asientos[0].asiento && this.zonas_anexas_disponibles) {
                    this.plazas_parking = true;

                    this.$nextTick(function() {
                        this.scrollTo('#plazas_parking');
                    });
                } else {
                    this.paso3 = true;

                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }
            },
            avanzarPaso(quiere_plaza) {
                if (!quiere_plaza) {
                    this.plazas_parking = false;
                    this.paso3 = true;
    
                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            }, 
            continuarDesdeSeleccionParcelas(parcelasSeleccionadas){
                this.parcelasSeleccionadas = parcelasSeleccionadas;
            },
            volverDesdeSeleccionParcelas(){
                this.pasoSeleccionParcelas = false;    
                this.botonesParcelasDeshabilitados = false;
                this.$nextTick(() => {
                    this.scrollTo('#voucher');
                });
                
            },
            continuarDespuesdeAsignaciones(datosParcelas){
                if (datosParcelas) {
                    this.cart_ids_parcelas = datosParcelas.cart_ids || [];
                    this.jet_id = datosParcelas.jet_id || null;
                    this.datos_parcelas_compradas = datosParcelas.datos_parcelas_resumen || [];
                }
                this.resumen = true;
                this.$nextTick(function() {
                    this.scrollTo('#resumen');
                });
            },
            async verificarDisponibilidadZonasYVentaActivada() {
                try{
                    if(!this.lista_abonados.activar_parcelas || !this.manager.activar_parcelas)
                    {
                        return false;
                    }

                    const params= {
                        lista_abonado_id: this.lista_abonados.id,
                        place_id: this.lista_abonados.recinto_parcela_id,
                    }

                    const response = await this.$store.dispatch('FRONT_PARCELAS_ZONAS', params);
                    const zonas = response.data.data;
                    const hayZonasDisponibles = zonas.some(zona => zona.esta_disponible > 0);
                    
                    return hayZonasDisponibles;
                }
                catch(error)
                {
                    console.error('Venta de parcela desactivada.');
                }
            },
            respuestaParcelas(quiereParcelas) {
                this.botonesParcelasDeshabilitados = true;
                if (quiereParcelas) {
                    this.quiereParcelasCambiarColor = false;
                    this.pasoSeleccionParcelas = true;
                    this.$nextTick(() => {
                        const elemento = document.getElementById('pasoSeleccionParcelas');
                        if (elemento) {
                            this.scrollTo('#pasoSeleccionParcelas');
                        }
                    });
                } else {
                    this.quiereParcelasCambiarColor = true;
                    this.resumen = true;
                    this.$nextTick(() => {
                        this.scrollTo('#resumen');
                    });
                }
            },
            volverDesdePreguntaParcelas() {
                this.preguntaParcelas = false;
                this.botonesParcelasDeshabilitados = false;
                this.voucher = true;
                this.$nextTick(() => {
                    this.scrollTo('#voucher');
                });
            },
            volverDesdeResumenCompra(){
                this.resumen = false;
                this.botonesParcelasDeshabilitados = false;
                
                if (this.pasoSeleccionParcelas) {
                    if (this.$refs.pasoParcelasRef) {
                        this.$refs.pasoParcelasRef.enviandoAsignaciones = false;
                        if (typeof this.$refs.pasoParcelasRef.habilitarSVGParcelas === 'function') {
                            this.$refs.pasoParcelasRef.habilitarSVGParcelas();
                        }
                    }
                    this.borrarParcelasSeleccionadas();
                    
                    this.$nextTick(() => {
                        this.scrollTo('#pasoSeleccionParcelas');
                    });
                } 
            },
            async borrarParcelasSeleccionadas() {
                if (this.cart_ids_parcelas.length === 0) {
                    this.limpiarDatosParcelas();
                    return;
                }

                for (const cartId of this.cart_ids_parcelas) {
                    try {
                        const params = { cart_id: cartId };
                        await this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params);
                    } catch (error) {
                        this.$toast.error(`Error borrando cart_id ${cartId}:`);
                    }
                }

                this.limpiarDatosParcelas();
            },
            limpiarDatosParcelas() {
                this.zonaParcelasSeleccionada = null;
                this.parcelasSeleccionadas = [];
                this.datos_parcelas_compradas = [];
            },
            sessionButacaDataPadre(data) {
                data.sesiones?.forEach(session => {
                    this.sessiones.push(session);
                });
            },
            continuarSinPlazaParking() {
                this.plazas_parking = false;
                this.paso1 = true;
                this.paso3 = true;

                this.$nextTick(() => {
                    this.scrollTo('#paso3');
                });
            }
        },
        components: {
            SeleccionarAsientosConRegiones, EnviosComponent,
            DatosAbonoComponent, ResumenCompraComponent, PagoPaycometComponent, CheckVoucherComponent,
            SeleccionarAsientosMapaGeneral, PageTitle, CuentaAtras, SeleccionarAsientoConSecciones, 
            PasoCompraParcelasOnline, PreguntaPrevioPasoParcelas, PasoExtraPlazasParking
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    button:disabled,
    .btn:disabled {
        cursor: not-allowed ;
        opacity: 0.6 ;
    }

    button:disabled:hover,
    .btn:disabled:hover {
        cursor: not-allowed ;
    }

    @media (max-width: 700px) {
        .button.large-button {
            min-width: 40vw !important;
            margin-right: 4%;
        }

        .form-button-responsive {
            display: flex;
            justify-content: center;
        }
        #compra-responsive {
            min-width: 45px;
            font-size: 13px;
        }
        #atras-responsive {
            min-width: 168px;
            font-size: 13px;
        }
    }    
</style>